"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openAiOrgs = exports.OpenAiModel = exports.openAiPricing = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
/**
 * NOTE: these are just for estimates, since the price can change at any time.
 *
 * @see https://openai.com/api/pricing/
 */
exports.openAiPricing = {
    dateChecked: "2024-09-23",
    "gpt-4": {
        usdPerMillionTokensInput: 30,
        usdPerMillionTokensOutput: 60,
    },
    "gpt-4o": {
        usdPerMillionTokensInput: 5,
        usdPerMillionTokensOutput: 15,
    },
    "gpt-4.1": {
        usdPerMillionTokensInput: 2.0,
        usdPerMillionTokensOutput: 8.0,
    },
    "gpt-4o-mini": {
        usdPerMillionTokensInput: 0.15,
        usdPerMillionTokensOutput: 0.6,
    },
    o3: {
        usdPerMillionTokensInput: 3.0,
        usdPerMillionTokensOutput: 15.0,
    },
    "o4-mini": {
        usdPerMillionTokensInput: 0.5,
        usdPerMillionTokensOutput: 1.5,
    },
    "o1-preview": {
        usdPerMillionTokensInput: 15,
        usdPerMillionTokensOutput: 60,
    },
};
exports.OpenAiModel = zod_1.default.enum(["gpt-4", "gpt-4.1", "gpt-4o", "gpt-4o-mini", "o3", "o4-mini", "o1-preview"]);
exports.openAiOrgs = {
    dev: "org-cjXNeAIbkyQh934rFIp5X1AB",
};
//# sourceMappingURL=llm.js.map